import { ExternalLinkIcon } from '@/shared/components/Icons'
import type { ProviderArtefactVersion, ProviderVcsStats } from '@/lib/apiTypes'
import { formatDate, formatCount } from '@/lib/format'

/** VCS repo-health header (M6): stars / recent commits / latest release + when it was cached.
 *  Renders nothing when the artefact has no resolvable repo (keeps the header clean). */
export function VcsStatsHeader({ stats, latestBuild }: {
  stats: ProviderVcsStats | null
  /** Newest terramantle build (base version + its `build` payload), if any. */
  latestBuild: { base: string; build: NonNullable<ProviderArtefactVersion['build']> } | null
}) {
  if (!stats && !latestBuild) return null
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px 20px', alignItems: 'center', marginBottom: 18, fontSize: '0.78rem' }}>
      {stats && (
        <>
      <span className="inline-dim">
        ★ stars <span className="dim-badge">{stats.stars != null ? formatCount(stats.stars) : '—'}</span>
      </span>
      {stats.is_fork && stats.parent_repo ? (
        <span className="dim" title="The source repo is a fork; stars, commits and releases are read from its parent">
          stats from parent <span className="dim-badge">{stats.parent_repo}</span>
        </span>
      ) : null}
      <span className="inline-dim">
        commits (90d) <span className="dim-badge">{stats.recent_commits != null ? `${stats.recent_commits}${stats.recent_commits_capped ? '+' : ''}` : '—'}</span>
      </span>
      <span className="inline-dim">
        releases (90d) <span className="dim-badge">{stats.releases_90d != null ? stats.releases_90d : '—'}</span>
      </span>
      <span className="inline-dim">
        latest release{' '}
        <span className="dim-badge">
          {stats.latest_release ?? '—'}
          {stats.latest_release_at != null ? ` · ${formatDate(stats.latest_release_at)}` : ''}
        </span>
      </span>
      {/* <span style={{ fontSize: '0.72rem', color: 'var(--text3)' }}>
        {stale ? `stats unavailable (${stats.fetch_error})` : `cached ${formatDate(stats.fetched_at)}`}
      </span> */}
        </>
      )}
      {latestBuild && (
        <>
          <span className="inline-dim">
            latest patched {' '}
            <span className="dim-badge">
              {latestBuild.build.full_version}
              {latestBuild.build.published_at != null ? ` · ${formatDate(latestBuild.build.published_at)}` : ''}
            </span>
          </span>
          {latestBuild.build.fork_commit_sha && (
            <span style={{ fontFamily: 'var(--mono)', color: 'var(--text3)' }}>
              {latestBuild.build.diff_url
                ? <a href={latestBuild.build.diff_url} target="_blank" rel="noopener noreferrer">commit {latestBuild.build.fork_commit_sha.slice(0, 10)} <ExternalLinkIcon size={10} /></a>
                : <>commit {latestBuild.build.fork_commit_sha.slice(0, 10)}</>}
            </span>
          )}
          {latestBuild.build.toolchain_bump && (
            <span className="dim">Go toolchain → {latestBuild.build.toolchain_bump}</span>
          )}

        </>
      )}
    </div>
  )
}

